<button
  data-cy="chartOptionsMenuButton"
  class="flex h-9 w-9 items-center justify-center rounded focus:outline-none"
  [ngClass]="{
    'hover:bg-m0': isHoverM === true,
    'hover:bg-m200': isHoverM === false
  }"
  #t1="tippy"
  [tp]="templateChartOptions"
  [tpHideOnEscape]="true"
  tpVariation="menu"
  className="my-menu"
  [tpOffset]="[0, 4]"
  (click)="clickMenu($event)"
>
  <m-dots-vertical-icon></m-dots-vertical-icon>
</button>

<ng-template #templateChartOptions>
  <div class="border-s4 bg-m0 w-64 rounded-md border-2 shadow-xl">
    <button
      data-cy="chartOptionsGoToFile"
      class="text-s1 hover:bg-m50 w-full px-4 py-2 text-left text-base focus:outline-none"
      (click)="t1.hide(); goToFile($event)"
      >Go to File</button
    >

    <div
      tp="Admin or Editor role required"
      placement="left"
      [tpIsEnabled]="currentChartUnit.canEditOrDeleteChart === false"
    >
      <button
        data-cy="chartOptionsEditInfo"
        class="text-s1 hover:bg-m50 w-full px-4 py-2 text-left text-base focus:outline-none"
        [ngClass]="{
          'text-s400 cursor-default':
            currentChartUnit.canEditOrDeleteChart === false
        }"
        (click)="t1.hide(); editChartInfo($event, currentChartUnit)"
        [disabled]="currentChartUnit.canEditOrDeleteChart === false"
        >Edit Info</button
      >
    </div>

    <div
      tp="Admin or Editor role required"
      placement="left"
      [tpIsEnabled]="currentChartUnit.canEditOrDeleteChart === false"
    >
      <button
        data-cy="chartOptionsDelete"
        class="text-s1 hover:bg-m50 w-full px-4 py-2 text-left text-base focus:outline-none"
        [ngClass]="{
          'text-s400 cursor-default':
            currentChartUnit.canEditOrDeleteChart === false
        }"
        (click)="t1.hide(); deleteChart($event, currentChartUnit)"
        [disabled]="currentChartUnit.canEditOrDeleteChart === false"
        >Delete</button
      >
    </div>
  </div>
</ng-template>
